import { goalNavigationData } from './data'

export const customGoalByKey = ({
  goal3Date,
  goal3IsCompleted,
  goal3Text,
  goal4Date,
  goal4IsCompleted,
  goal4Text,
  goal5Date,
  goal5IsCompleted,
  goal5Text,
}) => ({
  'goal 3': { date: goal3Date, text: goal3Text, isCompleted: goal3IsCompleted },
  'goal 4': { date: goal4Date, text: goal4Text, isCompleted: goal4IsCompleted },
  'goal 5': { date: goal5Date, text: goal5Text, isCompleted: goal5IsCompleted },
})

export const isGoalDefined = ({
  goalKey,
  goal3IsCompleted,
  goal4IsCompleted,
  goal5IsCompleted,
}) => {
  const optionalGoalCompletion = {
    goal3IsCompleted,
    goal4IsCompleted,
    goal5IsCompleted,
  }
  const goalData = goalNavigationData.find(goal => goal.key === goalKey)
  if (!goalData) return false
  if (!goalData.isOptional) return true

  return goalData.isCompletedProp
    ? optionalGoalCompletion[goalData.isCompletedProp]
    : true
}

export const formatShortDate = date =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  })

export const getTodayTimestamp = () => {
  const todaysDate = new Date()
  todaysDate.setHours(8, 0, 0, 0)
  return todaysDate.toISOString().slice(0, 19)
}

export const getClassesGoalStatus = ({
  goalDate,
  classesCreated,
  classCreationGoalValue,
  todayTimestamp = getTodayTimestamp(),
}) => {
  if (todayTimestamp < goalDate) {
    return null
  }

  let goalStatusText = null

  if (classesCreated < classCreationGoalValue) {
    goalStatusText = 'Goal Missed'
  }
  if (classesCreated === classCreationGoalValue) {
    goalStatusText = 'Goal Met'
  }
  if (classesCreated > classCreationGoalValue) {
    goalStatusText = 'Goal Exceeded'
  }

  return goalStatusText
}

export const getLessonsGoalStatus = ({
  goalDate,
  schoolwideLessonCompletionPercentage,
  lessonCompletionGoalValue,
  todayTimestamp = getTodayTimestamp(),
}) => {
  if (todayTimestamp < goalDate) {
    return null
  }

  let goalStatusText = null

  if (schoolwideLessonCompletionPercentage < lessonCompletionGoalValue) {
    goalStatusText = 'Goal Missed'
  }
  if (
    Math.floor(schoolwideLessonCompletionPercentage * 100) ===
    lessonCompletionGoalValue
  ) {
    goalStatusText = 'Goal Met'
  }
  if (schoolwideLessonCompletionPercentage > lessonCompletionGoalValue) {
    goalStatusText = 'Goal Exceeded'
  }

  return goalStatusText
}
